import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
// material-ui
import { makeStyles } from '@mui/styles';
import { Menu, Box, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Logout from "@mui/icons-material/Logout";
// import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
// project imports
import { Link as RouterLink } from 'react-router-dom';
import configData from '../../config';
import '../../assets/scss/style.css';
import Logo from '../../ui-component/Logo';
import { useMainLayoutStyles, handleApiError } from '../../utils/general';
import { useTheme } from "@mui/styles";
import axios from "axios";
import { useLocation } from "react-router-dom";
import AuthPermission from '../../utils/route-guard/AuthPermission';

// style constant
/**
 * useStyles
 *
 * @summary Generates JSS styles for the Header component, including avatar, icon button, and responsive layout.
 *
 * @description
 * Uses Material-UI's makeStyles to create a style object for the Header component. Defines styles for avatar, icon button, display container, and root layout, including transitions and responsive adjustments.
 *
 * @returns {Object} The generated classes object containing style definitions for the Header.
 *
 * @example
 * const classes = useStyles();
 */
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1
    },
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
    },
    iconButton: {
        backgroundColor: '#216bfd',
        color: 'white',
        '&:hover': {
            background: theme.palette.secondary.dark,
        },
      },
    disp : {
        bgcolor:'primary.light'
    },
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
    },
}));

//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//

const Header = ({ handleLeftDrawerToggle }) => {
    const classes = useMainLayoutStyles();
    const theme = useTheme();

    const [menuOpen, setMenuOpen] = useState(false);

    /**
 * handleMenuClose
 *
 * @summary Closes the user menu in the header by resetting the menu anchor state.
 *
 * @description
 * Sets the menu anchor state to null, closing the user menu dropdown in the header UI.
 *
 * @returns {void}
 *
 * @example
 * handleMenuClose();
 */
    function handleMenuClose(){
        setMenuOpen(null);
    }

    return (
        <React.Fragment>
                <Box component="span" sx={{ flexGrow: 1, margin: 0.5 }}>
                    <RouterLink to={'/dashboard'} style={{textDecoration: "none"}}>
                        <Logo />
                    </RouterLink>
                </Box>
            <div className={classes.root} >
                <AccountCircleIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#fff" : "#000000ff", width: "35px", height: "35px" }} onClick={(e) => setMenuOpen(e.currentTarget)}/>
                <Menu
                  anchorEl={menuOpen}
                  open={Boolean(menuOpen)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    style: {
                      backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark, 
                    },
                  }}
                >
                    <AuthPermission contentList='auth.view_user'>
                    <RouterLink to={'/user_profile_list'} style={{ textDecoration: "none", color: "grey" }}>
                        <MenuItem onClick={handleMenuClose}
                            sx={{
                              borderRadius: "8px",
                              transition: "all 0.3s",
                              '&:hover': {
                                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                                transform: "translateX(4px)",
                              }
                            }}
                        >
                            <PersonIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#fff" : "#000000ff" }}/>
                            <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>User List</span>
                        </MenuItem>
                    </RouterLink>
                    </AuthPermission>
                    <RouterLink to={'/logout'} style={{ textDecoration: "none", color: "grey" }}>
                        <MenuItem onClick={handleMenuClose}
                            sx={{
                              borderRadius: "8px",
                              transition: "all 0.3s",
                              '&:hover': {
                                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                                transform: "translateX(4px)",
                              }
                            }}
                        >
                            <Logout sx={{ color: theme.palette.themeMode == 'dark' ? "#fff" : "#000000ff" }}/>
                            <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Logout</span>
                        </MenuItem>
                    </RouterLink>
                </Menu>
            </div>
        </React.Fragment>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
